import React, { useEffect, useState } from "react";
import {
  Banner,
  Chip,
  Icon,
  IconList,
  Layout,
  Text,
} from "@kidslivesafe/sc-react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  selectShowReactivateConfirmation,
  setShowReactivateConfirmation,
} from "../../../features/subscriptions/subscriptionSlice";

import { useAppDispatch } from "../../../hooks/hooks";

const ReactivateBanner: React.FC = () => {
  const [displayBanner, setDisplayBanner] = useState<boolean>(false);
  const location = useLocation();
  const dispatch = useAppDispatch();

  const showReactivateConfirmation = useSelector(
    selectShowReactivateConfirmation,
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramValue = params.get("reactivated");
    if (paramValue === "true") {
      setDisplayBanner(true);
    }
  }, [location.search]);

  useEffect(() => {
    // check if state variable is set, if so, show banner
    if (showReactivateConfirmation) {
      setDisplayBanner(true);
      dispatch(setShowReactivateConfirmation(false));
    }
  }, [showReactivateConfirmation]);

  return (
    <Banner
      showBanner={displayBanner}
      setShowBanner={setDisplayBanner}
      position="bottom"
      displayX={true}
    >
      <Layout
        type="grid"
        gridProps={{
          templateColumns: "3fr-1fr",
          alignItems: "center",
        }}
        breakpointStyles={{
          tablet: {
            type: "grid",
            gridProps: {
              templateColumns: "2fr-1fr",
              alignItems: "center",
            },
          },
          mobile: {
            type: "flex",
            flexProps: { direction: "column", gap: "xs" },
          },
        }}
      >
        <Layout
          type="flex"
          flexProps={{
            direction: "column",
            gap: "xs",
            alignItems: "flex-start",
          }}
        >
          <Chip chipText="Account Active" color="success" />
          <Layout type="flex" flexProps={{ gap: "xs", alignItems: "center" }}>
            <Text color="success" tag="div">
              <Icon name={IconList.IconYes} size={24} />
            </Text>
            <Text size="sm" textAlign="left">
              You're all set! Your Membership has been successfully reactivated.
            </Text>
          </Layout>
        </Layout>
      </Layout>
    </Banner>
  );
};

export default ReactivateBanner;
